export const enum NsfwReason {
	Grid = 'grid',
	ChatBanner = 'chat-banner',
	TopBanner = 'top-banner',
	Profile = 'profile',
	NavigationLink = 'navigation-link',
}
